module.exports = __webpack_public_path__ + "img/header_returnIcon.8ec261d4.svg";